module.exports = __webpack_public_path__ + "img/banner-topic.2729b13b.png";